export default __webpack_public_path__ + "static/media/ElenaPrecisionSurveyDevice.ba739bbb.pdf";